<template>
  <div>
    <div class="btn-group-justify-end">
      <button @click="$router.push('grade/create')"
              class="button is-primary">등록</button>
    </div>

    <admin-simple-table :field_list="tableData"
                        :items="tableItems"
                        :filtered="filtered"
                        :allCount="allCount"
                        :filteredCount="filteredCount"
                        :table_width="1600"
                        @getData="getDataFromServer"
                        @ordering="ordering"
                        @selPageLength="selPageLength">

      <div slot="modify_delete" slot-scope="props">
        <button class="button"
                @click.stop.prevent="clickItem(props.item,'update')" style="margin-right:4px">수정</button>
      </div>

    </admin-simple-table>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'PartnerGradeList',
    mixins: [
      ListMixin
    ],

    data() {
      return {
        modalSignout: '',   // 탈퇴시킬 번호
      }
    },
    created(){
      this.init();
    },
    methods: {
      init() {
        this.initializing('member_partner_grade', 'member/partner-grade');
      },
      getDataFromServer() {
        this.getData();
      },
      clickItem(item, types) {
        // 수정
        if (types === 'update') {
          this.$router.push('grade/create?id=' + item.id);
        }
        // 삭제
        else if (types === 'delete') {

          let value = {
            id: item.id,
            url: 'member/partner-grade/',
            title: '파트너등급을 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      }
    }
  }
</script>

<style lang="styl" type="stylus" scoped>

</style>
